import { useState } from 'react';

import { CurrentInputType, InputNamesType } from 'src/viewLayer/components/nodes/InputNode/types';
import { UserInputType } from 'src/viewLayer/components/nodes/types.common';

const INITIAL_VALUE = '';

/* Outputs a state interface which looks as follows
{
  email: {
    inputValue: '',
    setInputValue: func,
    errorMessage: '',
    setErrorMessage: func,
    resetErrorMessage: func
  },
  password: {
    inputValue: '',
    setInputValue: func,
    errorMessage: '',
    setErrorMessage: func,
    resetErrorMessage: func
  },
  firstname: {
    inputValue: '',
    setInputValue: func,
    errorMessage: '',
    setErrorMessage: func,
    resetErrorMessage: func
  }
};
 */

export default (
  inputNames: InputNamesType[],
  userInput: Partial<UserInputType>,
  showSingleInput: boolean
): CurrentInputType => {
  const inputStateInterface: Partial<CurrentInputType> = {};

  // TODO: when changing to for...in loop, eslint is complaining about
  // React Hook "useState" may be executed more than once.
  // Possibly because it is called in a loop.
  // Why is it not for forEach?!?
  // eslint-disable-next-line unicorn/no-array-for-each
  inputNames.forEach((inputName, index) => {
    const [inputValue, setInputValue] = useState<string>(
      userInput[inputName] ||
      (JSON.parse(localStorage.getItem('userInput')) as Partial<UserInputType>)?.[inputName] ||
      INITIAL_VALUE
    );
    const [errorMessage, setErrorMessage] = useState(INITIAL_VALUE);
    // focus the first input field in the partials if there is more than one
    const [isFocused, setFocus] = useState(showSingleInput ? true : index === 0);

    inputStateInterface[inputName] = {
      inputValue,
      setInputValue,
      errorMessage,
      setErrorMessage,
      resetErrorMessage: () => setErrorMessage(INITIAL_VALUE),
      isFocused,
      setFocus
    };
  });

  return inputStateInterface;
};
